import { useEffect, useState } from 'react';

import { isFirstLoad, allmenu, isSingin } from '../redux/slices/initLoad/types';
import { store } from '../redux/store';
import request from '../helpers/requests';
import { saveData, saveImage, saveImagePath, getImage, getData, construirMapaImagenes } from '../helpers/indexedDbHelper';
import { constants, isLocalMirror } from '../config/constants';

export const useInit = () => {
  const [progress, setProgress] = useState(0); // progress in %
  /// En el kiosko el archivo ya está en el disco del iPad (lo bajó la app
  /// nativa y lo sirve el servidor local), así que solo se registra la ruta.
  /// Bajarlo otra vez como blob duplicaría cientos de MB y volvería a chocar
  /// con la cuota de IndexedDB.
  const downloadImage = async (url, id, changeimage) => {
    if (isLocalMirror) {
      await saveImagePath(id, url, changeimage);
      return;
    }

    try {
      const response = await fetch(url);
      const blob = await response.blob();
      await saveImage(id, { blob, changeimage });
    } catch (error) {
      console.error(`Error al descargar la imagen ${id}:`, error);
    }
  };

  const getInitData = async () => {
    const hash = '71277721124d0005k4z390b0apphabaneros.com2121';

    const previous = await getData('menu');

    const { data } = await request.get(`/all/menu/web/${hash}`);
    console.log('guardando menu');
    await saveData('menu', data);
    console.log('menu guardado');

    // ESPEJO LOCAL: camino corto y determinista.
    //
    // Las fotos ya están en el disco; sus rutas se derivan del JSON que
    // acabamos de guardar. No hay copia intermedia que pueda quedarse vieja,
    // ni 622 escrituras a IndexedDB en cada carga. Si se ve el texto nuevo,
    // se ve la foto nueva: es la misma fuente.
    if (isLocalMirror) {
      const total = construirMapaImagenes(data, {
        menus: constants.pathImagesMenu,
        categorias: constants.pathIconCategories,
      });
      console.log(`[Kiosko] Menú listo: ${total} imágenes mapeadas desde el JSON`);

      store.dispatch(isSingin(true));
      store.dispatch(isFirstLoad(false));
      return;
    }

    // ¿Cambió algo? Se compara el payload COMPLETO, no change_menu.
    //
    // change_menu no sirve: las descripciones y los títulos se editan con
    // updateLang(), que escribe en language_menus y no mueve esa bandera.
    // Comparando el JSON entero da igual de qué tabla venga el cambio.
    const huboCambios =
      JSON.stringify(previous?.value ?? null) !== JSON.stringify(data);

    if (isLocalMirror && !huboCambios) {
      console.log('[Kiosko] Menú sin cambios, nada que registrar');
      store.dispatch(isSingin(true));
      store.dispatch(isFirstLoad(false));
      return;
    }

    // Hay cambios: se siguen registrando las rutas de las imágenes abajo.
    // No se recarga: en el espejo local esta función se completa ANTES de que
    // se pinte nada (ver start()), así que las pantallas ya montan con los
    // datos nuevos y no hay doble render.

    const validImages = async (id) => {
      console.log('validando imagen');
      const data = await getImage(id);
      console.log('imagen validada');
      return data;
    };

    // Crear una lista de promesas para todas las imágenes
    const downloadPromises = [];
     
    const downloadCatPromises = [];
    let imagesMap = new Map();

    data.data.forEach((item) => {
      const images = [
        ...item.menus.map((menu) => ({
          url: menu.image,
          changeimage: menu.changeimage,
          id: `menu-image-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.imagehorizontal,
          changeimage: menu.changeimagehorizontal,
          id: `menu-image-h-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.image1,
          changeimage: menu.changeimage1,
          id: `menu-image-one-${menu.id}`,
        })),
        ...item.menus.map((menu) => ({
          url: menu.image2,
          changeimage: menu.changeimage2,
          id: `menu-image-two-${menu.id}`,
        })),
      ];

      images.forEach((img) => {
        if (img.url) {
          imagesMap.set(img.id, img);
        }
      });
    });


        data.data.forEach((item) => {
      const url = item.icon;
      const id = `menu-cat-${item.id}`;
      if (url) {
          const fullUrl = `${constants.pathIconCategories}/${url}`;
          downloadCatPromises.push(
            (async () => {
              const validImage = await validImages(id);
             
                if (!validImage || !validImage.data) {
                  console.log('Downloading image cat', fullUrl, id);
                  await downloadImage(fullUrl, id, "changeimage");
                }
            })()
          );
        }
        });
    

    let allImages = Array.from(imagesMap.values());
    const totalImages = allImages.length;
    let completed = 0;

    const processBatch = async (batch) => {
      const concurrencyLimit = 100;
      for (let i = 0; i < batch.length; i += concurrencyLimit) {
        const subBatch = batch.slice(i, i + concurrencyLimit);
        await Promise.all(
          subBatch.map(async ({ url, id, changeimage }) => {
            const fullUrl = `${constants.pathImagesMenu}/${url}`;
            const validImage = await validImages(id);

            if (
              !validImage ||
              !validImage.data ||
              validImage.data.changeimage != changeimage
            ) {
              console.log('Downloading image', fullUrl, id);
              await downloadImage(fullUrl, id, changeimage);
            }
            completed++;
            setTimeout(() => {
              setProgress(Math.round((completed / totalImages) * 100));
            }, [500]);
          }),
        );
      }
    };

    console.log('Esperar a que todas las imágenes se descarguen');
    // Esperar a que todas las imágenes se descarguen
    const chunkSize = 100;
    for (let i = 0; i < allImages.length; i += chunkSize) {
      const batch = allImages.slice(i, i + chunkSize);
      console.log('terminando imágenes se descarguen');
      await processBatch(batch);
    }

    // Actualizar el estado de Redux
    console.log('terminar proceso');
    store.dispatch(isSingin(true));
    store.dispatch(isFirstLoad(false));

  };

  useEffect(() => {
    const isGoodConnection = () => {
      const connection =
        navigator.connection ||
        navigator.mozConnection ||
        navigator.webkitConnection;
      if (connection) {
        const slowConnections = ['slow-2g', '2g'];
        if (
          slowConnections.includes(connection.effectiveType) ||
          connection.saveData
        ) {
          return false;
        }
      }
      return true;
    };

    const hasInternetAccess = async () => {
      // Servido desde el disco: no hay nada que comprobar.
      if (isLocalMirror) return true;

      // Con timeout explícito. Sin esto, en una red a medio levantar (WiFi
      // conectado pero sin internet) este fetch se queda colgado y la app se
      // queda en el splash indefinidamente.
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 5000);

      try {
        const response = await fetch(`${constants.apiServer}/health`, {
          method: 'GET',
          cache: 'no-store',
          signal: controller.signal,
        });

        return response.ok;
      } catch (error) {
        return false;
      } finally {
        clearTimeout(timer);
      }
    };

    const checkAndStart = async () => {
      // Espejo local: el menú y las imágenes ya están en el disco del iPad y los
      // sirve el servidor local. navigator.onLine da false sin WiFi y bloqueaba
      // la carga, dejando IndexedDB vacío y la app sin datos que mostrar.
      if (isLocalMirror) {
        console.log('Espejo local, cargando desde disco...');
        getInitData();
        return;
      }

      const online = navigator.onLine;
      const goodConnection = isGoodConnection();
      const hasInternet = await hasInternetAccess();

      if (online && goodConnection && hasInternet) {
        console.log('Conexión ok, comenzando init...');
        getInitData();
      } else {
        console.log('Sin conexión real o conexión muy lenta. Esperando...');
        store.dispatch(isSingin(true));
        store.dispatch(isFirstLoad(false));
      }
    };

    const start = async () => {
      // Si ya hay menú guardado se pinta de inmediato y la sincronización corre
      // por detrás. El splash solo tiene sentido en la primera instalación, que
      // es la única vez que de verdad hay que esperar a que algo baje.
      let hayMenuGuardado = false;
      try {
        const cached = await getData('menu');
        hayMenuGuardado = Boolean(cached?.value?.data?.length);
      } catch (e) {
        hayMenuGuardado = false;
      }

      if (hayMenuGuardado && isLocalMirror) {
        // Espejo local: comprobar y actualizar ANTES de pintar.
        //
        // Todo sale del disco del iPad, así que esto cuesta milisegundos. A
        // cambio, las pantallas montan UNA sola vez y ya con los datos nuevos:
        // se acaba el salto de "menú viejo -> refresh -> menú nuevo".
        try {
          await getInitData();
        } catch (e) {
          console.warn('[Kiosko] Fallo al refrescar desde disco:', e);
        }
        store.dispatch(isSingin(true));
        store.dispatch(isFirstLoad(false));
        return;
      }

      if (hayMenuGuardado) {
        // Remoto: no se puede esperar a la red, se pinta ya y se actualiza
        // por detrás.
        store.dispatch(isSingin(true));
        store.dispatch(isFirstLoad(false));
        checkAndStart();
        return;
      }

      // Primera instalación: se mantiene el margen original.
      setTimeout(checkAndStart, 3000);
    };

    start();
  }, []);

  return { progress };
};

// NEED TO HANDLE MULTIPLE TIME API CALLING getInitData, bcz in index file we are calling
// useInit hook for get progress data so bcz of that api is called 4 times,but we need to manage it for maximum 2 time
// we can pass one flag from index and in this hook add condition that if we find flag then fon't call api otherwise call api
